<template>
  <div>
    <v-btn
      :color="color||'primary'"
      :text="text||false"
      :outlined="outlined||false"
      :loading="isSelecting || isLoading"
      @click="onButtonClick"
    >{{ title }}</v-btn>
    <input
      ref="uploader"
      class="d-none"
      type="file"
      accept="*"
      :multiple="multiple||false"
      @change="onFileChanged"
    />
  </div>
</template>

<script>
export default {
  props: ["text", "color", "outlined", "title", "multiple", "isLoading"],
  data() {
    return {
      isSelecting: false
    };
  },
  methods: {
    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      if (e) {
        if (e.target.files.length > 0) {
          if (!this.multiple) {
            this.uTitle = e.target.files[0].name;
            this.$emit("file-update", e.target.files[0]);
          } else {
            let title = "";
            for (let i = 0; i < e.target.files.length; i++) {
              title += e.target.files[i].name + ", ";
            }
            title = title.slice(0, title.length - 2);
            this.uTitle = title;
            this.$emit("file-update", e.target.files);
          }
        } else {
          this.uTitle = null;
          this.$emit("file-update");
        }
      }
    },
    clear() {
      this.$refs.uploader.value = "";
      this.$emit("file-update");
      this.uTitle = null;
    }
  }
};
</script>
